/**
 * Configuration des routes pour le système d'authentification
 */

export const AUTH_ROUTES = {
  // Routes principales
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  
  // Routes de redirection
  USER_PROFILE: '/profile',
  ADMIN: '/admin',
  ORGANIZATION: '/organization',
  DEFAULT: '/',
  
  // Routes protégées par authentification
  PROTECTED: [
    '/profile',
    '/admin',
    '/organization',
    '/events/create',
    '/events/edit',
    '/staff/profile',
    '/staff/applications'
  ],
  
  // Routes protégées par rôle administrateur
  ADMIN_PROTECTED: [
    '/admin'
  ],
  
  // Routes protégées par rôle organisation
  ORGANIZATION_PROTECTED: [
    '/organization'
  ]
};
